import React, { useState, useEffect, useMemo, useCallback } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import _ from 'lodash'
import queryString from 'query-string'
import {
  Axios,
  Grid,
  Segment,
  DataTable,
  Table,
  Checkbox,
  ConditionWrapper,
  BaseForm as Form,
  Text,
} from 'component/base'

export const DaigaeEnjokinDetail = withRouter(props => {
  const {
    history,
    enableQueryCondition,
    multiple,
    selectedId,
    onSelectChange,
    refresh,
    daigae_enjokin_id,
  } = props

  const query = useMemo(
    () =>
      queryString.parse(window.location.search, {
        parseNumbers: true,
        parseBooleans: true,
      }),
    [window.location.search]
  )

  const path = useMemo(() => window.location.pathname, [
    window.location.pathname,
  ])

  const defaultCondition = useMemo(() => {
    return {}
  }, [])

  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [selectedIds, setSelectedIds] = useState([])
  const [condition, setCondition] = useState(
    _.assign({}, defaultCondition, enableQueryCondition ? query : {})
  )

  useEffect(() => {
    setSelectedIds(
      multiple
        ? selectedId && _.isArray(selectedId)
          ? selectedId
          : []
        : selectedId
        ? [selectedId]
        : []
    )
  }, [selectedId])

  useEffect(() => {
    onSelectChange(
      selectedIds,
      _.filter(data, row =>
        _.find(selectedIds, id => row.daigae_enjokin_meisai_id === id)
      )
    )
  }, [selectedIds])

  useEffect(() => {
    setCondition(condition =>
      enableQueryCondition
        ? _(condition).assign(query).value()
        : _(condition).value()
    )
  }, [defaultCondition, enableQueryCondition, query])

  useEffect(() => {
    callApi(condition)
    setSelectedIds([])
  }, [condition, refresh])

  const handleConditionChange = (condition, isOnClear) => {
    setCondition(isOnClear ? defaultCondition : condition)
    if (enableQueryCondition)
      isOnClear
        ? history.push(`${path}`)
        : history.push(`${path}?${queryString.stringify(condition)}`)
  }

  const callApi = async condition => {
    setLoading(true)
    const { data, error } = await Axios.ajax.get(
      `/api/staff/kumiaiin/daigae_enjokin/${daigae_enjokin_id}/daigae_enjokin_meisai`,
      {
        params: {
          ...condition,
        },
      }
    )
    setLoading(false)
    if (error) return
    setData(data)
  }

  const handleChangeSelect = (selectedId, selected) => {
    setSelectedIds(selectedIds =>
      selected
        ? multiple
          ? _.union(selectedIds, [selectedId])
          : [selectedId]
        : _.filter(selectedIds, id => id !== selectedId)
    )
  }

  const TableRowWithProps = useCallback(
    props => (
      <TableRow
        {...props}
        history={history}
        handleChangeSelect={handleChangeSelect}
      />
    ),
    [history, handleChangeSelect]
  )

  return (
    <>
      <Segment basic loading={loading} style={{ padding: '0em' }}>
        <ConditionWrapper
          defaultCondition={defaultCondition}
          condition={condition}
          onConditionChange={handleConditionChange}
          FormElement={SearchElement}
          enableSidebar={false}
          compact
        >
          <DataTable
            name='kumiaiin-daigae_enjokin-detail'
            sortable
            filterable
            tableHeight='50vh'
            tableHeader={TableHeader}
            tableRow={TableRowWithProps}
            data={data}
            bottomControl={<></>}
            selectedIds={selectedIds}
          />
        </ConditionWrapper>
      </Segment>
    </>
  )
})

DaigaeEnjokinDetail.propTypes = {
  enableQueryCondition: PropTypes.bool,
  multiple: PropTypes.bool,
  selectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  onSelectChange: PropTypes.func,
}

DaigaeEnjokinDetail.defaultProps = {
  enableQueryCondition: false,
  multiple: false,
  selectedValue: '',
  onSelectChange: () => {},
}

const TableHeader = props => {
  const { withOrder, handleSort, column, direction } = props

  return withOrder(
    <Table.Row>
      <Table.HeaderCell style={{ width: '3.0rem' }} content='#' />
      <Table.HeaderCell
        style={{ width: '10.0rem' }}
        sorted={column === 'torihikisaki_cd' ? direction : null}
        onClick={() => handleSort('torihikisaki_cd')}
        content='組合員コード'
      />
      <Table.HeaderCell
        style={{ width: '10.0rem' }}
        sorted={column === 'torihikisaki_name' ? direction : null}
        onClick={() => handleSort('torihikisaki_name')}
        content='組合員名'
      />
      <Table.HeaderCell
        style={{ width: '10.0rem' }}
        sorted={column === 'shozoku_busho_cd' ? direction : null}
        onClick={() => handleSort('shozoku_busho_cd')}
        content='所属部署コード'
      />
      <Table.HeaderCell
        style={{ width: '10.0rem' }}
        sorted={column === 'shozoku_busho_name' ? direction : null}
        onClick={() => handleSort('shozoku_busho_name')}
        content='所属部署名称'
      />
      <Table.HeaderCell
        style={{ width: '10.0rem' }}
        sorted={column === 'rikuun_shikyoku_ryaku_name' ? direction : null}
        onClick={() => handleSort('rikuun_shikyoku_ryaku_name')}
        content='車両登録番号'
      />
      <Table.HeaderCell
        style={{ width: '10.0rem' }}
        sorted={column === 'shatai_no' ? direction : null}
        onClick={() => handleSort('shatai_no')}
        content='車体番号'
      />
      <Table.HeaderCell
        style={{ width: '10.0rem' }}
        sorted={column === 'toroku_date' ? direction : null}
        onClick={() => handleSort('toroku_date')}
        content='登録日'
      />
      <Table.HeaderCell
        style={{ width: '10.0rem' }}
        sorted={column === 'daigae_enjokin_gaku' ? direction : null}
        onClick={() => handleSort('daigae_enjokin_gaku')}
        content='代替援助金額'
      />
      <Table.HeaderCell
        style={{ width: '10.0rem' }}
        sorted={column === 'chosei_daigae_enjokin_gaku' ? direction : null}
        onClick={() => handleSort('chosei_daigae_enjokin_gaku')}
        content='代替援助金額（調整額）'
      />
      <Table.HeaderCell
        style={{ width: '10.0rem' }}
        sorted={column === 'choseigo_daigae_enjokin_gaku' ? direction : null}
        onClick={() => handleSort('choseigo_daigae_enjokin_gaku')}
        content='代替援助金額（調整後）'
      />
      <Table.HeaderCell
        style={{ width: '10.0rem' }}
        sorted={column === 'chosei_riyu' ? direction : null}
        onClick={() => handleSort('chosei_riyu')}
        content='調整理由'
      />
    </Table.Row>
  )
}

const TableRow = props => {
  const { withOrder, data, selectedIds, handleChangeSelect } = props || {}

  const {
    daigae_enjokin_meisai_id: id,
    // daigae_enjokin_id,
    // torihikisaki_id,
    torihikisaki_cd,
    torihikisaki_name,
    rikuun_shikyoku_ryaku_name,
    shashu_no,
    shashu_no_kana,
    toroku_no,
    shatai_no,
    toroku_date,
    daigae_enjokin_gaku,
    chosei_daigae_enjokin_gaku,
    choseigo_daigae_enjokin_gaku,
    chosei_riyu,
    shozoku_busho_cd,
    shozoku_busho_name,
  } = data || {}

  console.log(shashu_no_kana)

  const [isSelected, setIsSelected] = useState(
    selectedIds.indexOf(id) >= 0 ? true : false
  )

  const checkboxChange = (event, { value, checked }) => {
    event.stopPropagation()
    setIsSelected(checked)
    handleChangeSelect(value, checked)
  }

  return withOrder(
    <Table.Row
      positive={isSelected}
      onClick={() => {
        setIsSelected(state => !state)
        handleChangeSelect(id, !isSelected)
      }}
    >
      <Table.Cell
        style={{ width: '3.0rem' }}
        textAlign='center'
        content={
          <Checkbox checked={isSelected} onChange={checkboxChange} value={id} />
        }
      />
      <Table.Cell style={{ width: '10.0rem' }} content={torihikisaki_cd} />
      <Table.Cell style={{ width: '10.0rem' }} content={torihikisaki_name} />
      <Table.Cell style={{ width: '10.0rem' }} content={shozoku_busho_cd} />
      <Table.Cell style={{ width: '10.0rem' }} content={shozoku_busho_name} />
      <Table.Cell
        style={{ width: '10.0rem' }}
        content={_.join(
          [
            rikuun_shikyoku_ryaku_name || '',
            shashu_no || '',
            shashu_no_kana || '',
            toroku_no || '',
          ],
          ' '
        )}
      />
      <Table.Cell style={{ width: '10.0rem' }} content={shatai_no} />
      <Table.Cell style={{ width: '10.0rem' }} content={toroku_date} />
      <Table.Cell
        style={{
          width: '10.0rem',
          textAlign: 'right',
        }}
        content={<Text.Comma content={daigae_enjokin_gaku} />}
      />
      <Table.Cell
        style={{
          width: '10.0rem',
          textAlign: 'right',
        }}
        content={<Text.Comma content={chosei_daigae_enjokin_gaku} />}
      />
      <Table.Cell
        style={{
          width: '10.0rem',
          textAlign: 'right',
        }}
        content={<Text.Comma content={choseigo_daigae_enjokin_gaku} />}
      />
      <Table.Cell style={{ width: '10.0rem' }} content={chosei_riyu} />
    </Table.Row>
  )
}

const SearchElement = props => {
  const { nav, condition } = props

  return (
    <>
      <Grid.Column
        style={{
          display: !nav || condition.torihikisaki_cd ? 'block' : 'none',
        }}
      >
        <Form.Textbox.Standard
          value={condition.torihikisaki_cd}
          label='組合員コード'
          name='torihikisaki_cd'
        />
      </Grid.Column>
      <Grid.Column
        style={{
          display: !nav || condition.torihikisaki_name ? 'block' : 'none',
        }}
      >
        <Form.Textbox.Standard
          value={condition.torihikisaki_name}
          label='組合員名'
          name='torihikisaki_name'
        />
      </Grid.Column>
    </>
  )
}
